import { forwardRef, ButtonHTMLAttributes, ReactNode } from 'react';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** 'md' = 44px on mobile, 36px ≥md (default). 'sm' = 36px both. 'lg' = 48px both. */
  size?: 'sm' | 'md' | 'lg';
  /** REQUIRED for a11y on icon-only buttons. */
  'aria-label': string;
  children: ReactNode;
};

const SIZE_CLASSES: Record<NonNullable<IconButtonProps['size']>, string> = {
  sm: 'w-9 h-9',
  md: 'w-11 h-11 md:w-9 md:h-9',
  lg: 'w-12 h-12',
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { size = 'md', className = '', children, type = 'button', ...rest },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        className={`inline-flex items-center justify-center rounded-full text-ink-2 hover:bg-ivory-2 transition-colors touch-manipulation ${SIZE_CLASSES[size]} ${className}`}
        {...rest}
      >
        {children}
      </button>
    );
  }
);
IconButton.displayName = 'IconButton';

export default IconButton;
